import { render, staticRenderFns } from "./orderListOfDistributor.vue?vue&type=template&id=90d2e348&scoped=true"
import script from "./orderListOfDistributor.vue?vue&type=script&lang=js"
export * from "./orderListOfDistributor.vue?vue&type=script&lang=js"
import style0 from "./orderListOfDistributor.vue?vue&type=style&index=0&id=90d2e348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2e348",
  null
  
)

export default component.exports